import React, { useEffect } from 'react';
// @ts-ignore
import zelij3 from '../../assets/zelij3.png';
import { t } from '../../contexts/translations';

interface LegalSectionProps {
  title: string;
  children: any;
}

const LegalSection = ({ title, children }: LegalSectionProps) => (
  <section className="mb-12">
    <h2 className="text-2xl md:text-3xl font-bold text-orange-700 mb-6 flex items-center gap-2">
      <span className="w-3 h-3 bg-orange-500 rounded-full"></span>
      {title}
    </h2>
    <div className="text-gray-700 text-lg leading-relaxed space-y-4">
      {children}
    </div>
  </section>
);

const PolitiqueConfidentialite = ({ language = 'fr' }: { language?: string }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="w-full pt-20 min-h-screen bg-white relative"
      style={{
        backgroundImage: `url(${zelij3})`,
        backgroundRepeat: 'repeat',
        backgroundSize: '400px',
        backgroundAttachment: 'fixed',
        zIndex: 0,
      }}
    >
      <div className="absolute inset-0 bg-white/80 z-0 pointer-events-none" />
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-orange-700 mb-4 drop-shadow-lg">{t('privacyTitle', language)}</h1>
          <div className="w-24 h-1 bg-orange-500 mx-auto rounded-full"></div>
        </div>
        <div className="bg-white/90 rounded-3xl shadow-xl border border-orange-100 p-8 md:p-12">
          <LegalSection title={t('privacyIntroduction', language)}>
            <p>
              {t('privacyIntroductionContent', language).split('\n').map((line: string, i: number) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          </LegalSection>
          <LegalSection title={t('privacyDataCollection', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('privacyDataCollectionContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('privacyDataUse', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('privacyDataUseContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('privacyDataSharing', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('privacyDataSharingContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('privacyDataSecurity', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('privacyDataSecurityContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('privacyYourRights', language)}>
            <div className="whitespace-pre-line text-gray-700">
              {t('privacyYourRightsContent', language)}
            </div>
          </LegalSection>
          <LegalSection title={t('privacyContact', language)}>
            <p className="text-gray-700">
              {t('privacyContactContent', language).split('contact@palaisTouristique.ma')[0]}
              <a href="mailto:contact@palaisTouristique.ma" className="text-orange-600 hover:underline">contact@palaisTouristique.ma</a>
            </p>
          </LegalSection>
        </div>
      </div>
    </div>
  );
};

export default PolitiqueConfidentialite;